import { Injectable } from '@angular/core';

@Injectable()
export abstract class IEUserMessagePopup {
    abstract OpenIEUserMessagePopup(): void;
}

